import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import ArrowIcon from '~/components/SVG/Arrow.svg?react';

const styles: { icon: SxProps<Theme> } = {
  icon: (theme: Theme) => ({
    width: '28px',
    height: '28px',
    color: theme.palette.grey.additionalGrey,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      width: '20px',
      height: '20px',
    },
  }),
};

const Arrow = () => {
  return <Box component={ArrowIcon} sx={styles.icon} />;
};

export default Arrow;
